import React from 'react'

import {
    Row,
    Col,
    Card,
    Button,
    Input,
    Radio,
    Tag,
    message,
    Table,
    Modal,
    Divider
} from 'antd'

import {
    _postSynonym,
    _getSynonyms,
    _deleteSynonym,
    _getSynonymSuggestion
} from '../../services'

const debounce = require('debounce')

const { confirm } = Modal

const types = {
    EXPLICIT: "EXPLICIT",
    GROUP: "GROUP"
}

const DEFAULT_STATE = {
    activeSynonymId: false,
    mappingType: types.GROUP,
    terms: [''],
    primaryTerm: '',
}

class SynonymsEditor extends React.Component {
    render(){

        const { mappingType, terms } = this.state

        return(
            <div>
                {this.renderStyles()}
                <Row type="flex" gutter={12} style={{margin: 12}}>
                    <Col span={12}>
                        <Card
                        style={{height: '100%'}}
                        title={this.state.activeSynonymId?"Edit Synonym":"Add Synonym"}>
                            <Row style={{marginBottom: 24}}>
                                <div style={{marginBottom: 8}}>
                                    Type of Mapping: 
                                </div>
                                <Radio.Group onChange={(e) => this.setState({ mappingType: e.target.value })} value={this.state.mappingType}>
                                    <Radio value={types.GROUP}>Group</Radio>
                                    <Radio value={types.EXPLICIT}>Explicit</Radio>
                                </Radio.Group>
                            </Row>
                            {mappingType === types.EXPLICIT &&
                            <Row style={{marginBottom: 24}}>
                                <div style={{marginBottom: 8}}>
                                    Primary Term: 
                                </div>
                                <Input
                                    style={{width: 300}}
                                    placholder="ipod"
                                    value={this.state.primaryTerm}
                                    onChange={(e)=>this.setState({ primaryTerm: e.target.value })}
                                />
                            </Row>}
                            <Row>
                                <div style={{marginBottom: 8}}>
                                    <Button
                                        size="small"
                                        style={{
                                            marginRight: 8
                                        }}
                                        onClick={this.handleAddTerm}
                                        shape="circle"
                                        type="primary"
                                        icon="plus"
                                    />
                                    {`${mappingType == types.EXPLICIT?'Secondary ':''}Terms:`}
                                </div>
                                {terms.map( (_term, index) => {
                                    return(
                                        <Row style={{marginBottom: 16}}>
                                            <Input
                                                autoFocus={index == terms.length -1}
                                                onPressEnter={this.handleAddTerm}
                                                onChange={(e)=>this.handleChangeTerm(e.target.value, index)}
                                                style={{width: 300}}
                                                value={_term}
                                            />
                                            <Button
                                                size="small"
                                                type="danger"
                                                style={{
                                                    marginLeft: 8
                                                }}
                                                onClick={()=>this.handleRemoveTerm(index)}
                                                shape="circle"
                                                icon="minus"
                                            />
                                        </Row>
                                    )
                                })}
                            </Row>
                            <Row
                            style={{
                                marginTop: 16
                            }}>
                                {this.state.activeSynonymId &&
                                <Button
                                    style={{marginRight: 12}}
                                    onClick={this.handleCancelEdit}
                                >
                                    Cancel
                                </Button>
                                }
                                <Button
                                    type="primary"
                                    onClick={this.handleSubmit}
                                >
                                    Submit
                                </Button>
                            </Row>
                        </Card>
                    </Col>
                    <Col span={12}>
                        <Card
                        style={{height: '100%'}}
                        title="Suggester">
                            {this.renderSuggester()}
                        </Card>
                    </Col>
                </Row>
                <Card style={{margin: 12}}>
                    {this.renderTable()}
                </Card>
            </div>
        )
    }

    constructor(props){
        super(props)

        this.state = {

           ...DEFAULT_STATE,

            synonyms: [],
            page: 1,
            limit: 13,
            total: 0,
            activeTerm: '',
            searchParam: '',
            loading: true,
            suggestions: false
        }

        this.getSynonyms()

        this.executeSearch = debounce(this.executeSearch, 400)
        this.getSynonymSuggestion = debounce(this.getSynonymSuggestion, 400)
    }

    getSynonymSuggestion = () => {

        const { activeTerm } = this.state

        if( activeTerm.length > 0 ){
            _getSynonymSuggestion(activeTerm)
            .then(res => {

                const { suggestions, lexName } = res.data

                this.setState({
                    suggestions,
                    lexName 
                })                
            })
        }

    }

    handleAddTerm = () => {

        const { terms } = this.state

        this.setState({
            terms: [...terms, '']
        })
    }

    handleEdit = (synonym) => {

        this.setState({
            mappingType: synonym.primaryTerm? types.EXPLICIT: types.GROUP,
            terms: synonym.terms,
            primaryTerm: synonym.primaryTerm,
            activeSynonymId: synonym._id
        })

    }

    handleCancelEdit = () => {
        this.setState({
            ...this.state,
            ...DEFAULT_STATE
        })
    }

    handleChangeTerm = (term, index) => {

        const { terms } = this.state

        this.getSynonymSuggestion()

        this.setState({
            activeTerm: term,
            terms: [...terms.slice(0, index), term, ...terms.slice(index + 1)],
            searchParam: term
        }, this.executeSearch)
    }

    handleClickSuggestion = (term) => {

        const { terms } = this.state

        if( !terms.includes(term) ){
            this.setState({
                terms: [...terms, term]
            })
        } else {
            return message.warning("Term already included")
        }

    }

    handleDelete = (synonymId) => {

        _deleteSynonym(synonymId)
        .then( res => {
            message.success("Successful deletion!")

            this.getSynonyms()
            // this.setState({
            //     synonyms: this.state.synonyms.filter( _synonym => _synonym._id != synonymId )
            // })
        })

    }

    handleRemoveTerm = (index) => {

        const { terms } = this.state

        this.setState({
            terms: [...terms.slice(0, index), ...terms.slice(index + 1)]
        })

    }

    handleSubmit = () => {

        const { primaryTerm, mappingType, activeSynonymId } = this.state

        const terms = this.state.terms.map( _term => _term.trim() ).filter( _term => _term.length > 0 )

        if( terms.length == 0 ){
            return message.warning("At least one term is required!")
        }

        if( mappingType == types.EXPLICIT && (!primaryTerm || primaryTerm.length == 0) ){
            return message.warning("PRIMARY TERM is required if mapping type is EXPLICIT!")
        }

        if( mappingType == types.GROUP && terms.length < 2 ){
            return message.warning("At least two terms are required if mapping type is GROUP")
        }

        _postSynonym({
            activeSynonymId,
            terms,
            primaryTerm
        })
        .then( res => {

            this.setState({
                searchParam: terms[terms.length - 1],
                activeTerm: ''
            })

            const { synonym } = res.data
            
            // this.setSynonym(synonym, activeSynonymId)
            this.getSynonyms()

            this.handleCancelEdit()

            if( activeSynonymId ){
                return message.success("Successfully edited synonym")
            }

            message.success("Successfully added synonym")
        })


    }
    
    getSynonyms = () => {

        this.setState({
            loading: true
        })
        
        const { page, limit, searchParam } = this.state
        
        _getSynonyms({
            searchParam,
            page,
            limit
        })
        .then( res => {
            
            const { synonyms, count } = res.data

            this.setState({
                synonyms,
                total: count,
                loading: false
            })

        })

    }

    handleSearch = (e) => {
        this.setState({
            searchParam: e.target.value
        }, this.executeSearch )
    }

    renderSuggester = () => {

        const { suggestions, lexName, activeTerm } = this.state

        if( !suggestions || suggestions.length == 0 || activeTerm.length == 0 ){
            return (
                <Row type="flex" justify="center" align="middle">
                    <b>No Suggestions Found</b>
                </Row>
            )
        }

        return(
            <div>
                <div>
                    <span
                        style={{
                            fontSize: 48,
                            fontWeight: 600
                        }}
                    >
                        {activeTerm}
                    </span>
                </div>
                <div>
                    <i>
                        {lexName}
                    </i>
                </div>
                <Row
                style={{marginTop: 24}}
                type="flex">
                    {suggestions.map( _synonym => (
                        <Col>
                            <span 
                            onClick={()=>this.handleClickSuggestion(_synonym)}
                            className="synonym-tag">
                                {_synonym}
                            </span>
                        </Col>
                    ))}
                </Row>
            </div>
        )

    }

    renderStyles = () => {
        return(
            <style dangerouslySetInnerHTML={{__html: `
                .synonym-tag {
                    font-size: 18px;
                    background: #e8e8e8;
                    margin: 0px 12px 12px 0px;
                    padding: 4px;
                    display: inline-block;
                    cursor: pointer;
                }

                .synonym-tag:hover {
                    opacity: 0.8;
                }
            `}}/>
        )
    }

    renderTable = () => {

        const { page, limit, total, synonyms, loading } = this.state

        const columns = [{
            title: "#",
            render: (synonym, _synonym, index) => {
                console.log(index)
                return (
                    <span style={{ paddingLeft: 8 }}>
                        {total - (index + ((page - 1) * limit))}
                    </span>
                )
            }
        },{
            title: "String",
            dataIndex: "_string"
        },{
            title: "Terms",
            dataIndex: 'terms',
            render: ( terms ) => {
                return terms.map( _term => (
                    <span style={{marginRight: 12}}>
                        {_term}
                    </span>
                ))
            }
        },{
            title: "Primary Term",
            dataIndex: 'primaryTerm',
            render: ( primaryTerm ) => {
                if( primaryTerm ) {
                    return primaryTerm
                } else {
                    return '-'
                }
            }
        },{
            title: 'Actions',
            render: (synonym) => {
                return (
                    <span>
                        <a onClick={()=>this.handleEdit(synonym)}>
                            Edit
                        </a>
                        <Divider type="vertical"/>
                        <a onClick={()=>{
                            return confirm({
                                centered: true,
                                title: 'Confirm delete?',
                                content: `You are deleting the mapping ${synonym._string}`,
                                onOk: ()=>this.handleDelete(synonym._id)
                            })
                        }}>
                            Delete
                        </a>
                    </span>
                )
            }
        }]

        return (
            <div>
                <Row style={{marginBottom: 16}}>
                    <Input
                        value={this.state.searchParam}
                        placeholder="Search term"
                        style={{width: 600}}
                        onChange={this.handleSearch}
                    />
                    <Button
                        style={{marginLeft: 12}}
                        onClick={this.getSynonyms}
                        shape="circle"
                        type="primary"
                        icon="reload"
                    />
                </Row>
                <Table
                    size="small"
                    pagination={{
                        current: page,
                        pageSize: limit,
                        total,
                        onChange: (nextPage) => this.setState({ page: nextPage }, this.getSynonyms)
                    }}
                    loading={loading}
                    columns={columns}
                    dataSource={synonyms}
                />
            </div>
        )

    }

    executeSearch = () => {
        this.getSynonyms()
    }

    setSynonym = (synonym, edit) => {
        
        const { synonyms } = this.state

        if( !edit ){
            return this.setState({
                synonyms: [synonym, ...synonyms]
            })
        }

        this.setState({
            synonyms: synonyms.map( _synonym => {
                if( _synonym._id == synonym._id ){
                    _synonym = synonym
                }
                return _synonym
            }) 
        })

    }
}

export default SynonymsEditor


// WEBPACK FOOTER //
// ./src/components/product/synonyms-editor.js